import { useDispatch, useSelector } from "react-redux";
import CustomPopup from "../../../../Common/components/CustomPopup/CustomPopup";
import BundleComparator from "../../../../Retrofit/components/Devices/BundleComparator/BundleComparator";
import ComparisonBar from "../../../../Retrofit/components/Devices/ComparisonBar";
import CorrespondingCrossComponent from "../../../../Retrofit/components/Devices/CorrespondingCrossComponent/CorrespondingCrossComponent";
import FiltersWrapper from "../../../../Retrofit/components/Devices/FiltersWrapper";
import { useGetRetrofitBundles } from "../../../../Retrofit/components/useGetRetrofitBundles";
import { choosableColumns, defaultColumns } from "../../../../Retrofit/store/data/retrofitData";

import { updateConfiguration } from "../../../../Common/store/slices/common";
import {
  clearBundlesToCompare,
  selectBundlesToCompare,
  selectCountOfBundles,
  selectCurrentAxisFilters,
  selectCurrentFiltersStepperStep,
  selectFetchedBundles,
  selectOrderBy,
  selectPaging,
  selectRowsToShow,
  setOrderBy,
  setPaging,
  setShowAxisPopup
} from "../../../../Retrofit/store/slices/retrofit";
import {
  selectSelectedBundle,
  setAxisOptionsIsValid,
  setBundleChanged,
  setSelectedBundle,
  setSelectedCartesianAdaptationKit
} from "../../../store/slices/cartesian";

const SelectBundlePopup = ({ opened, onClose, ...props }) => {
  const dispatch = useDispatch();
  const selectedBundle = useSelector(selectSelectedBundle);

  const selectBundle = async (bundle) => {
    dispatch(setSelectedBundle(bundle));
    dispatch(setSelectedCartesianAdaptationKit(bundle?.cartesianAdaptationKit));
    dispatch(setBundleChanged(true));
    dispatch(setShowAxisPopup(false));
    dispatch(setAxisOptionsIsValid(false));
    // clear the compare list
    dispatch(clearBundlesToCompare());
    dispatch(updateConfiguration());
    onClose();
  };

  const bundlesToCompare = useSelector(selectBundlesToCompare);
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);
  const currentFilters = useSelector(selectCurrentAxisFilters);

  // Get fetched (and filtered) bundles from redux
  const fetchedBundles = useSelector(selectFetchedBundles);
  const countOfBundles = useSelector(selectCountOfBundles);

  const rowsToShow = useSelector(selectRowsToShow);
  const paging = useSelector(selectPaging);
  const orderBy = useSelector(selectOrderBy);

  // const handleApplyFilters = (axisId, newFilters) => {
  //   dispatch(setAxisFilters({ axisId, filters: newFilters }));
  // };

  const { isFetching: isFetchingBundles, refetch: refetchBundles } = useGetRetrofitBundles(currentFilters);

  return (
    <CustomPopup
      opened={opened}
      onClose={onClose}
      wideWidth
      popUpHeight="85vh"
      data-testid="select-bundle-popup"
      {...props}
    >
      <div className={`SelectBundlePopup ${bundlesToCompare?.length > 0 ? "mb-[60px]" : ""}`}>
        {currentFiltersStep === 1 && (
          <>
            <FiltersWrapper filters={currentFilters} axisId={1} refetchBundles={refetchBundles} />
            <CorrespondingCrossComponent
              filters={currentFilters}
              selectedBundle={selectedBundle}
              onSelectBundle={selectBundle}
              defaultColumns={defaultColumns}
              choosableColumns={choosableColumns}
              bundles={fetchedBundles}
              isFetchingBundles={isFetchingBundles}
              paging={paging}
              setPaging={(p) => dispatch(setPaging(p))}
              rowsToShow={rowsToShow}
              orderBy={orderBy}
              setOrderBy={(order) => dispatch(setOrderBy(order))}
              countOfBundles={countOfBundles}
            />
          </>
        )}
        {currentFiltersStep === 2 && <BundleComparator onSelectBundle={selectBundle} />}

        {bundlesToCompare?.length > 0 && <ComparisonBar />}
      </div>
    </CustomPopup>
  );
};
export default SelectBundlePopup;
